import { render, staticRenderFns } from "./subDataset.vue?vue&type=template&id=45299400&scoped=true&"
import script from "./subDataset.vue?vue&type=script&lang=js&"
export * from "./subDataset.vue?vue&type=script&lang=js&"
import style0 from "./subDataset.vue?vue&type=style&index=0&id=45299400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45299400",
  null
  
)

export default component.exports